<template>
  <div class="UserCenter " style="background: #fff">
    <div class="container">
      <ld-statusbar />
      <!-- 顶部条 -->
      <div class="bg-khmain">
        <div>
          <ul class="kh-dl">
            <li class="kh-dl1">
              <span style="overflow: hidden">
                <img src="../images/home/tox.png" class="tx">
              </span>
            </li>
            <li style="width:60%;">
              <div class="kh-dl2">
                <span class="white font16 usercenter-name">{{ userInfo.empInfo.empName }} | {{ userInfo.empInfo.empNo }}</span>
                <router-link
                  v-ldsk="userInfo&&userInfo.vipCorp?userInfo.vipCorp.corpNo:''"
                  class="white font16"
                  to="/userCenter/company"
                >
                  <span class="usercenter-company">{{ userInfo&&userInfo.vipCorp?userInfo.vipCorp.fullname:'' }}
                    <!-- <i class="iconfont">&#xeb09;</i> -->
                  </span>
                </router-link>
              </div>
            </li>
            <li>
              <router-link to="/userCenter/settings">
                <van-icon
                  class="white"
                  name="setting-o"
                  size="18"
                  style="margin-right: 40px;"
                />
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <!--    模式  -->
      <div class="kh-ms">
        <ul class="kh-ms-ul">
          <li v-for="tab in khList"
              :key="tab.link"
              :to="{ path: tab.link, query: tab.query }"
              @click="kh_List(tab)" :class="'item'+tab.i">
            <span>{{ tab.title }}</span>
            <span><van-icon name="arrow" /></span>
          </li>
        </ul>
        <!--        常用信息-->
        <ul class="kh-ms-ul">
          <li v-for="tab in khcyxx"
              :key="tab.link"
              :to="{ path: tab.link, query: tab.query }" @click="kh_List(tab)" :class="'khcyxx'+tab.i">
            <span>
              {{ tab.title }}
            </span>
            <span><van-icon name="arrow" /></span>
          </li>
        </ul>
        <!--        帮助文档-->
        <ul class="kh-ms-ul">
          <li v-for="tab in khwd"
              :key="tab.link"
              :to="{ path: tab.link, query: tab.query }" @click="kh_List(tab)">
            <span>{{ tab.title }}</span>
            <span><van-icon name="arrow" /></span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabbar, TabbarItem, NoticeBar, Cell, CellGroup ,Grid, GridItem,Icon } from 'vant'
import { mapGetters } from 'vuex'
import MescrollVue from 'mescroll.js/mescroll.vue'
import { localget } from 'Utils/storage.js'
import ldStatusbar from 'Common/ldStatusbar'

const tabbarList = [
  {
    link: '/allorder?findType=2',
    title: 'A101',//待付款
    img: 'icontianchongxing-'
  },
  {
    link: '/allorder?findType=3',
    title: 'A102',//待出行
    img: 'iconhanglixiang'
  },
  {
    link: '/allorder?findType=4',
    title: 'A103',//退/改签
    img: 'icontuikuan'
  },
  {
    link: '/allorder?findType=1',
    title: 'A104',//全部订单
    img: 'icondingdan'
  }
]

const khList = [
  {
    link: '/xxx',
    title: '我的差标',
    i: 1
  },
  {
    link: '/tripList',
    title: '我的申请单 ',
    i:2
  },
  {
    link: '/allorder?findType=1',
    title: '我的订单 ',
    i: 3
  },
]
// 常用信息
const khcyxx= [
  {
    link: '/userCenter/CommonInfo',
    title: '常用信息 ',
    i:1
  },
  {
    link: '/userCenter/empList',
    title: '员工管理 ',
    i:2
  },
]
const khwd= [
  {
    link: '/xxx',
    title: '帮助文档 ',
    i:1
  },
]
export default {
  name: 'UserCenter',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [NoticeBar.name]: NoticeBar,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon .name]: Icon ,
    MescrollVue,
    ldStatusbar
  },
  data () {
    return {
      tabbarList,
      khList,
      khcyxx,
      khwd,
      subNavList: [
        {
          link: '/userCenter/approvalList',
          query: { index: 2 },
          title: 'K206',//需要我审批
          img: 'iconweibiaoti-145'
        },
        {
          link: '/userCenter/approvalList',
          query: { index: 3 },
          title: '我提交的审批',
          img: 'iconweibiaoti-143'
        },
        // {
        // 	link: '/userCenter/NeedOrder',
        // 	title: '我的需求单',//我的需求单
        // 	img: 'iconweibiaoti-147'
        // },
        {
          link: '/tripList',
          title: '我的出差申请',
          img: 'iconweibiaoti-142'
        },
      ],
      navList: [
        {
          link: '/userCenter/CommonInfo',
          title: 'A107',//常用信息
          img: 'iconweibiaoti-146'
        },
        {
          link: '/userCenter/empList',
          title: 'A108',//员工管理
          img: 'iconyonghuguanli'
        },
        // {
        // 	link: '/userCenter/invitEmployees',
        // 	title: '邀请员工', //邀请员工
        // 	img: 'iconadduser'
        // },
      ],
      down: { use: false }
    }
  },
  computed: {
    ...mapGetters(['loginConfig', 'userInfo', 'loginNotices'])
  },
  created() {
    if(!this.userInfo||!this.userInfo.vipCorp){
      let userInfo = localget('userInfo')
      if(userInfo){
        this.$store.commit('SET_USERINFO',userInfo)
      }
    }

    if(this.userInfo.vipCorp){
      if(this.userInfo.vipCorp.bookStyle==1){
        this.subNavList.splice(3, 1)
      }
    }else{
      let userInfo = localget('userInfo')
      if(userInfo){
        this.$store.commit('SET_USERINFO',userInfo)
        //如果是单订模式 删除申请单的入口
        if (userInfo.vipCorp && userInfo.vipCorp.bookStyle==1) {
          this.subNavList.splice(3, 1)
        }
      }
    }
  },
  methods:{
    kh_List(item,index){
      console.log(item)
      this.$router.push(item.link)
    }
  }
}
</script>

<style lang="less" scoped>
.UserCenter {
     height: 100%;
    .centerwrapper {
        height: calc(100vh - 122px);
         -webkit-overflow-scrolling: touch;
    }
    .pad-b-50{
        padding-bottom: 60px;
    }

  .container {
    //padding: 8px 8px 0;

    .setting {
      padding: 20px 10px;
    }

    .info-card {
      margin-top: 5px;
      padding: 15px;
      box-shadow: 0px 6px 10px 0px
        rgba(24, 23, 23, 0.02);

      .chatface {

        img {
          vertical-align: text-top;
        }
      }

      .empNo {
        padding: 2px 8px;
        //background-image: linear-gradient(90deg,
        //  #556070 0%,
        //  #7a7e85 100%);
        background-color: #ff923e;
        background-blend-mode: normal,
          normal;
        border-radius: 20px;
        margin-top: 0.2rem;

        .icon-id {
          color: #f6e9e3;
        }
      }
    }


    .message {
      border-top: 1px solid @color-background-gray;
      padding: 8px 0;

      .icon-new {
        width: 28px;
        vertical-align: middle;
      }

      .van-notice-bar {
        height: 24px;
        padding: 0 5px;
        background: transparent;
      }
    }

    .service {
      margin: 5px 0 !important;

      h4, p {
        margin: 0;
      }

      .service-icon {
        text-align: center;
        padding: 14px !important;

        i {
          font-size: 32px;
        }
      }
    }

    .nav-list {
      overflow: hidden;

      .van-cell {
        padding: 16px;

        .van-cell__title {
          font-size: @font-size-14
        }
      }

      .iconfont {
        margin-right: 12px;
      }
    }
  }
}
.kh-dl{
  display: flex;
  // width: 365px;
  width: 100%;
  height: 48px;
  padding: 0 25px;
  position: absolute;
  // left: 25px;
  top: 50px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  li{
    div{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      flex-wrap: nowrap;
    }
  }
}
//康辉样式
.tx{
  width: 48px;
  height: 48px;
  line-height: 35px;
  text-align: center;
  border-radius: 20px;
  overflow: hidden;
}
.kh-dl1{
  height: 100%;
  width: 46px;
  line-height: 51px;
  text-align: center;
  border-radius: 50px;
}
.kh-dl2{
  .usercenter-name{
    font-size: 18px;
  }
  .usercenter-company{
    font-size: 10px;
  }
}

//个人中心小模块
.kh-ms{
  height: 500px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 10px;
}
.kh-ms-ul{
  // width: 395px;
  width: 100%;
  background: #EEEEF6;
  margin: auto;
  margin-top: 20px;
  border-radius: 5px;
  li{
    height: 55px;
    line-height: 55px;
    padding: 0px 10px 0 10px;
    margin: 0px 10px 0 10px;
    display: flex;
    justify-content: space-between;
  }

  .item1{
    border-bottom: 1px solid #fff;
  }
  .item2{
    border-bottom: 1px solid #fff;
  }
  .khcyxx1{
    border-bottom: 1px solid #fff;
  }
}

</style>
